import { RolexContainer } from '@components/_rolex/Container'
import { Text } from '@components/rolex-ui/Text'
import { Article } from '@generated'
import { cn } from '@lib/cn'
import { FC } from 'react'

type Props = {
  data: Article
}

const excludeAttributeIds = [57, 31]

const ProductProperties: FC<Props> = ({ data }) => {
  const filteredProperties = data?.articleAttributes?.filter(
    (item) => !excludeAttributeIds.includes(item?.attributeID || 0),
  )

  return (
    <RolexContainer
      fullWidth="mobile"
      className={cn(
        'bg-rolexBeige py-[60px]',
        'md:columns-3 md:px-16 md:py-[8vh]',
        'lg:px-28 lg:py-[10vh]',
      )}
    >
      <RolexContainer as="div" fullWidth="desktop">
        {filteredProperties?.map((item) => (
          <div className={cn('mb-4 break-inside-avoid')} key={item?.attributeID}>
            <Text variant="body20" className="text-rolexBrown">
              {item?.attributeName}
            </Text>
            <Text variant="body20" weight="light">
              {item?.attributeValue}
            </Text>
          </div>
        ))}
      </RolexContainer>
    </RolexContainer>
  )
}

export default ProductProperties
